import { useMemo } from "react";

import { AgCharts } from "ag-charts-react";
import {
  CartesianChartModule,
  CategoryAxisModule,
  LegendModule,
  LineSeriesModule,
  ModuleRegistry,
  NumberAxisModule
} from "ag-charts-community";

import dateUtils from "@plannel/utils/date-util";

// ag-charts 13은 AgCharts.create() 전에 쓰는 모듈을 등록해야 한다(미등록 시 런타임에
// "AG Charts - No modules have been registered"로 렌더가 죽는다). 아래 options에서 실제로
// 쓰는 것만 등록한다 — 카테시안 차트 + line 시리즈 + category/number 축 + legend 키.
// 앱 전역 진입점(index.js)이 아니라 이 파일에서 등록한다(factory-plan/common/grid.js의
// CellSpanModule 등록과 같은 방침 — 2026-08-11 사용자 지시로 FP 스코프에 국한). 현재 앱 전체에서
// ag-charts 소비자는 이 파일 하나뿐이라 여기가 가장 좁은 범위이고, FP 차트가 늘어나면
// factory-plan/common/chart.js 로 뺀다. registerModules는 멱등이라 중복 호출도 안전하다.
ModuleRegistry.registerModules([
  CartesianChartModule,
  LineSeriesModule,
  CategoryAxisModule,
  NumberAxisModule,
  LegendModule
]);

/**
 * 툴 공급 누적 수량 차트 — old ToolSupplyTabChart.jsx 대응. 통합 차트(Integrated Charts)가 아니라
 * ag-charts-react 독립 사용(saas-fp/docs/fp-frontend-migration/CLAUDE.md AG Grid절 — Enterprise 통합 차트 미보유).
 * old는 Chart.js stepped line(before)이었고, ag-charts의 line 시리즈 interpolation "step"으로 동일하게
 * 표현한다. old처럼 앞뒤에 빈 라벨 + 시작(toolCnt)/끝(마지막 totalCnt) 포인트를 덧붙여 계단선의
 * 시작/끝 구간이 보이게 한다.
 *
 * props: dataSource(툴 공급 이력 목록, supplyTs asc 정렬 + totalCnt 계산 완료 상태), initialToolCnt
 */
const ToolSupplyTabChart = ({ dataSource, initialToolCnt }) => {
  const chartData = useMemo(() => {
    if (!dataSource || dataSource.length === 0) return [];

    const rows = dataSource.map(row => ({
      label: dateUtils.formatDateTime(row.supplyTs),
      totalCnt: row.totalCnt,
    }));

    return [
      { label: "", totalCnt: initialToolCnt ?? rows[0].totalCnt },
      ...rows,
      { label: "", totalCnt: rows[rows.length - 1].totalCnt },
    ];
  }, [dataSource, initialToolCnt]);

  const options = {
    data: chartData,
    series: [
      {
        type: "line",
        xKey: "label",
        yKey: "totalCnt",
        stroke: "rgb(237, 112, 45)",
        strokeWidth: 2,
        interpolation: { type: "step", position: "start" },
        marker: { enabled: false },
      },
    ],
    legend: { enabled: false },
    axes: [
      { type: "category", position: "bottom" },
      { type: "number", position: "left" },
    ],
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <AgCharts options={options} style={{ width: "100%", height: "100%" }} />
    </div>
  );
};

export default ToolSupplyTabChart;
